---
pageId: feature-templates
title: Szablony trackerów
description: Wyselekcjonowana biblioteka gotowych trackerów — 30 szablonów w 7 obszarach życia, każdy z rozsądnie dobranymi metrykami.
category: features
order: 2
lang: pl
slug: funkcje/szablony
updated: 2026-08-06
---

Szablony odpowiadają na problem pustej kartki. Zamiast z góry decydować o metrykach, jednostkach i skalach, startujesz od dopracowanego trackera i dopasowujesz go do swojego życia.

## Co jest w bibliotece

Katalog trzyma 30 gotowych szablonów w siedmiu obszarach:

- **Zdrowie** — Woda, Sen, Waga, Kroki, Suplementy
- **Sport** — Bieganie, Siłownia, Rower, Pływanie, Joga
- **Umysł** — Nastrój, Medytacja, Stres, Wdzięczność
- **Relacje** — Czas z rodziną, Telefon do bliskich, Kontakt z przyjaciółmi, Randka
- **Hobby** — Czytanie, Projekt kreatywny, Instrument, Granie
- **Praca** — Głęboka praca, Pomodoro, Spotkania, Rozwój zawodowy
- **Finanse** — Dzienne wydatki, Dzień bez wydatków, Oszczędności, Zakupy impulsywne

## Co szablon prekonfiguruje

Każdy szablon niesie nazwę, opis, kolor, ikonę i uporządkowany zestaw metryk — z typami, jednostkami, granicami skal i już podjętą decyzją, jak każdy wpis zmienia wartość. Pierwsza metryka jest główna. Szablony trzymają się maksymalnie 3 metryk, więc każdy z nich mieści się w planie Free.

## Gdzie spotykasz szablony

**Przy pierwszym logowaniu** ekran powitalny proponuje siedem starterów — Woda, Sen, Kroki, Siłownia, Nastrój, Czytanie, Głęboka praca. Zaznacz dowolną liczbę i naciśnij **Dodaj wybrane**: trackery powstają natychmiast, każdy przypięty do pasującej kategorii (Zdrowie, Sport, …), którą Samlla w razie potrzeby tworzy za Ciebie.

**Na stronie tworzenia** (**Utwórz tracker**) pełny katalog siedzi za siedmioma pigułkami kategorii. Tutaj szablon działa inaczej: kliknięcie wypełnia formularz tworzenia i nic jeszcze nie powstaje. Przejrzyj metryki — popraw typy, jednostki albo harmonogram — i dopiero **Utwórz tracker** zapisuje. Każde kolejne kliknięcie w szablon nadpisuje formularz, więc możesz swobodnie przeglądać.

## Szablon to punkt startu

Tracker utworzony z szablonu jest zwykłym trackerem. Zmień mu nazwę, kolor, dodaj albo dezaktywuj metryki, przestaw harmonogram — nic z jego pochodzenia go nie ogranicza.
